/**
 * Страница менеджера: демо уведомлений (manager/notifications-demo).
 *
 * Маркер инициализации — кнопка onclick="createTestNotifications()" в HTML.
 * Конфиг — window.notificationsDemoConfig (routes).
 *
 * Функционал — глобальные window.createTestNotifications/clearAllNotifications,
 * привязанные к onclick-атрибутам в шаблоне.
 */

function setup() {
    const $ = window.jQuery || window.$;
    if (!$) return;

    const config = window.notificationsDemoConfig;
    if (!config) return;

    const showToast = window.showToast || function () {};

    window.createTestNotifications = function () {
        $.ajax({
            url: config.routes.test,
            type: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success(response) {
                if (response.success) {
                    showToast('success', 'Test notifications created! Check the bell icon in the header.');
                    if (typeof window.loadNotificationsCount === 'function') {
                        window.loadNotificationsCount();
                    }
                }
            },
            error() {
                showToast('error', 'Failed to create test notifications');
            },
        });
    };

    window.clearAllNotifications = function () {
        $.ajax({
            url: config.routes.clear,
            type: 'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success(response) {
                if (response.success) {
                    showToast('success', 'All notifications cleared!');
                    if (typeof window.loadNotificationsCount === 'function') {
                        window.loadNotificationsCount();
                    }
                }
            },
            error() {
                showToast('error', 'Failed to clear notifications');
            },
        });
    };
}

setup();
